import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import {
  RequirementDefinitionDataSourceSettingsItem,
  useRequirementDefinitionsSettings
} from "./useRequirementDefinitionsSettings";
import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";
import { useRequirementDefinitionQuery } from "./useRequirementDefinitionQuery";

export const QUERY_EXTENDED_REQUIREMENT_DEFINITION =
  "QUERY_EXTENDED_REQUIREMENT_DEFINITION";

export interface ExtendedRequirementDefinition
  extends IRequirementDefinitionResponse {
  dataSource?: RequirementDefinitionDataSourceSettingsItem & {
    contextType?: SharedFileRequestContextType;
  };
}

export const useExtendedRequirementDefinition = (
  requirementDefinitionId: string
) => {
  const queryRequirement = useRequirementDefinitionQuery(
    requirementDefinitionId
  );
  const querySettings = useRequirementDefinitionsSettings({
    enabled: queryRequirement.isSuccess,
    requirementDefinitions: queryRequirement.data
      ? [queryRequirement.data]
      : [],
    fetch: "all"
  });

  return useWSQuery<ExtendedRequirementDefinition, WSServiceError>(
    [QUERY_EXTENDED_REQUIREMENT_DEFINITION, requirementDefinitionId],
    () => {
      const requirement = queryRequirement.data!;

      const extendedRequirement = {
        ...requirement,
        dataSource: querySettings.data?.[requirement.dataSourceId!]
      };

      return Promise.resolve(extendedRequirement);
    },
    {
      enabled: queryRequirement.isSuccess && querySettings.isFetched
    }
  );
};
